import React from 'react';

function LabelSectionDashboardFeature(props) {
  return (
    <div className='container mt-4'>
      <p className='fw-light text-uppercase mt-4 mb-2'>{props.title}</p>
    </div>
  );
}

export default LabelSectionDashboardFeature;
